<template>
  <div class="main-container">
    <div style="width: 100%;">
      <el-input
        style="max-width: 400px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="usersLists"
        :select-options="selectOption"
        :search-options="{enabled: true, 
        searchFn: searchTable,
                externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <!-- {{1}} -->
          <span
            v-if="props.column.field == 'full_name'"
          >{{ props.row.firstName }} {{ props.row.lastName }}</span>
          <span v-else>{{props.row[props.column.field]}}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  // components: {
  //   Inventory
  // },
  data() {
    return {
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [
        { field: "id", label: "ID", sortable: "true" },
        {
          field: "actualAmount",
          label: "Transaction Amount",
          sortable: "true"
        },
        { field: "status", label: "Status", sortable: "true" },
        {
          field: "transactionType",
          label: "Transaction Type",
          sortable: "true"
        },
        { field: "createdAt", label: "Transaction Time", sortable: "true" }
      ],
      usersLists: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: { title: "", content: "" }
    };
  },
  computed: {
    ...mapGetters(["getUserById", "getDevices", "getUserSession"]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
     searchTable(row, col, cellValue, searchTerm) {
      return Object.values(row).join('<%>').toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    navTo(user) {
      this.$router.push({ name: this.details, params: { userId: user } });
      console.log(user);
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getHistory() {
      const HTTP = this.$httpUtils.instance;
      let url = `/transactionHistories?filter[where][userId]=${
        this.getUserSession.id
      }`;
      if (this.$can("read", "all")) {
        url = `/transactionHistories`;
        if (this.$route.params.userId) {
          url = `/transactionHistories?filter[where][userId]=${
            this.$route.params.userId
          }`;
        }
      }
      const container = this;
      HTTP.get(url)
        .then(response => {
          // container.$router.push({path: `/device/${response.data.data.inverter_number}`});
          this.usersLists = response.data;
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  mounted() {
    this.getHistory();
    // console.log(this.getDummy)
  }
};
</script>
<style scoped>
.card-title {
  font-size: 2.6rem;
}
table th,
table th span {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shs/Wallet.vue